import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-row gap-3 flex-wrap" }
const _hoisted_2 = { class: "flex flex-row-reverse w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-4 border-b-4 border-h-primary-800 custom-card mt-4" }, {
      header: _withCtx(() => [
        _createElementVNode("h6", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Adicionais", en: "Additionals" })), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
            return (_openBlock(), _createElementBlock("p", {
              key: index,
              class: "options"
            }, _toDisplayString(option.name), 1))
          }), 128))
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_Button, {
            id: `card-item-edit-btn`,
            class: "btn-simple w-fit !p-0 !px-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onEdit()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { name: "hi-solid-pencil" }),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.edit")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "btn-delete w-fit",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmDeleteModal()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { name: "md-delete" }),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.delete")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ConfirmDialog, {
      group: "options-card",
      class: "custom-dialog",
      draggable: false,
      style: { width: '80vw', maxWidth: '700px' }
    })
  ], 64))
}